import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
   <>
   <div className="footer">
            <div className="copyright">
                <p>Copyright © Designed &amp; Developed by <Link>Adret Software</Link> 2023</p>
            </div>
        </div>
   </>
  )
}
